import React from 'react';
import {
    Pickaxe, Axe, Box, Coins, Wheat,
    Hammer, Gem, Beaker, Zap,
    CircuitBoard, Battery, Search,
    Apple
} from 'lucide-react';
import type { Resource } from '../../types';

interface ItemIconProps {
    id: Resource | string;
    size?: number;
    className?: string;
    style?: React.CSSProperties;
}

export const ItemIcon: React.FC<ItemIconProps> = ({ id, size = 24, className = "", style = {} }) => {
    const baseStyle = { ...style };

    // Helper to get icon based on ID inclusion
    if (id === 'gold') return <Coins size={size} color="#eab308" style={baseStyle} className={className} />;

    if (id.includes('pickaxe')) return <Pickaxe size={size} color="#94a3b8" style={baseStyle} className={className} />;

    if (id.includes('wood') || id === 'charcoal') return <Axe size={size} color="#b45309" style={baseStyle} className={className} />;

    if (id.includes('bar') || id.includes('ingot')) return <Box size={size} color="#fdba74" style={baseStyle} className={className} />;

    // Stones / Ores
    if (id.includes('ore') || ['stone', 'coal', 'copper', 'tin', 'iron', 'titanium', 'obsidian', 'meteorite'].includes(id)) {
        // Dynamic color based on material?
        let color = "#78716c"; // stone
        if (id.includes('copper')) color = "#f97316";
        if (id.includes('iron')) color = "#94a3b8";
        if (id.includes('gold')) color = "#eab308";
        if (id.includes('mithril')) color = "#60a5fa";
        if (id.includes('adamantite')) color = "#22c55e";
        if (id.includes('runite')) color = "#3b82f6";
        return <Gem size={size} color={color} style={baseStyle} className={className} />;
    }

    if (id.includes('plate') || id.includes('helmet')) return <Box size={size} color="#cbd5e1" style={baseStyle} className={className} />;

    // Farming
    if (['potato', 'carrot', 'corn', 'wheat', 'hops', 'herbs'].some(x => id.includes(x))) {
        return <Wheat size={size} color="#84cc16" style={baseStyle} className={className} />;
    }
    if (['food', 'stew', 'bread', 'beer'].some(x => id.includes(x))) {
        return <Apple size={size} color="#fb923c" style={baseStyle} className={className} />;
    }

    // High Tech
    if (['wire', 'circuit', 'processor', 'battery', 'ai_core'].some(x => id.includes(x))) {
        return <CircuitBoard size={size} color="#22d3ee" style={baseStyle} className={className} />;
    }
    if (['energy', 'plasma', 'laser', 'void'].some(x => id.includes(x))) {
        return <Zap size={size} color="#c084fc" style={baseStyle} className={className} />;
    }

    // Default
    return <Box size={size} color="#64748b" style={baseStyle} className={className} />;
};
